<ndt-register-view
  [name]="name"
  [totalCount]="totalCount"
  [callState]="callState"
  [hasNextPage]="hasNextPage"
  [pagingCallState]="pagingCallState"
  [hideHeader]="hideHeader"
  [searchText]="searchText"
  [showCreate]="userPrivileges?.canAdd && showCreate"
  [showAllUsersControl]="showAllUsersControl"
  (create)="onCreate()"
  (quickFilterChange)="onQuickFilterChange($event)"
  (loadMore)="onLoadMore()"
  >
  <ndt-register-quick-filter>
    @if (showAllUsersControl) {
      <mat-slide-toggle
        class="slide-toggle"
        id="toggle-show-system-users"
        color="primary"
        [ngModel]="showAllUsers"
        (ngModelChange)="showAllUsersChange($event)"
        >
        Show All Users
      </mat-slide-toggle>
    }
  </ndt-register-quick-filter>
  <ndt-register-quick-filter>
    <mat-slide-toggle
      class="slide-toggle"
      id="toggle-include-inactive-users"
      color="primary"
      [ngModel]="includeInactive"
      (ngModelChange)="includeInactiveChange($event)"
      >Include Inactive</mat-slide-toggle
      >
    </ndt-register-quick-filter>
    <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
        <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
        <tr lcs-row *lcsResponsiveRowDef></tr>
        <ng-container lcsColumnDef="name" width="2">
          <th
            lcs-header-cell
            *lcsHeaderCellDef
            id="name-column-header"
            ndtSortColumn
            (emitter)="onOrderingOptionsChange($event)"
            [sortDirection]="getOrderingOption(orderingOptions, 'name')"
            sortField="name"
            >Name<mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let user">
              <a [routerLink]="getRouterLink(user.userId)">
                {{ user.name }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="username" width="2">
            <th
              lcs-header-cell
              *lcsHeaderCellDef
              id="username-column-header"
              ndtSortColumn
              (emitter)="onOrderingOptionsChange($event)"
              [sortDirection]="getOrderingOption(orderingOptions, 'username')"
              sortField="username"
              >Username<mat-icon class="mat-icon-sort">{{ getSort('username') }}</mat-icon></th
              >
              <td lcs-cell *lcsCellDef="let user">
                <a [routerLink]="getRouterLink(user.userId)">
                  {{ user.username }}
                </a>
              </td>
            </ng-container>
            <ng-container lcsColumnDef="emailAddress" width="3">
              <th
                lcs-header-cell
                *lcsHeaderCellDef
                id="email-address-column-header"
                ndtSortColumn
                (emitter)="onOrderingOptionsChange($event)"
                [sortDirection]="getOrderingOption(orderingOptions, 'emailAddress')"
                sortField="emailAddress"
                >Email<mat-icon class="mat-icon-sort">{{ getSort('emailAddress') }}</mat-icon></th
                >
                <td lcs-cell *lcsCellDef="let user">
                  <a [routerLink]="getRouterLink(user.userId)">
                    {{ user.emailAddress }}
                  </a>
                </td>
              </ng-container>
              <ng-container lcsColumnDef="isActive" width="1">
                <th lcs-header-cell *lcsHeaderCellDef id="active-column-header">Active</th>
                <td lcs-cell *lcsCellDef="let user">
                  <a [routerLink]="getRouterLink(user.userId)">
                    @if (user.isActive) {
                      <mat-icon>check</mat-icon>
                    }
                  </a>
                </td>
              </ng-container>
              <ng-container lcsColumnDef="isLocked" width="3">
                <th
                  lcs-header-cell
                  *lcsHeaderCellDef
                  id="email-address-column-header"
                  ndtSortColumn
                  (emitter)="onOrderingOptionsChange($event)"
                  [sortDirection]="getOrderingOption(orderingOptions, 'isLocked')"
                  sortField="isLocked"
                  >Locked<mat-icon class="mat-icon-sort">{{ getSort('isLocked') }}</mat-icon></th
                  >
                  <td lcs-cell *lcsCellDef="let user">
                    <a [routerLink]="getRouterLink(user.userId)">
                      @if (user.isLocked) {
                        <mat-icon>check</mat-icon>
                      }
                    </a>
                  </td>
                </ng-container>
                <ng-container lcsColumnDef="lastLoggedIn" width="3">
                  <th
                    lcs-header-cell
                    *lcsHeaderCellDef
                    id="last-logged-in-column-header"
                    ndtSortColumn
                    (emitter)="onOrderingOptionsChange($event)"
                    [sortDirection]="getOrderingOption(orderingOptions, 'lastLoggedIn')"
                    sortField="lastLoggedIn"
                    >Last Logged In<mat-icon class="mat-icon-sort">{{ getSort('lastLoggedIn') }}</mat-icon></th
                    >
                    <td lcs-cell *lcsCellDef="let user">
                      <a [routerLink]="getRouterLink(user.userId)">
                        {{ user.lastLoggedIn | date : 'M/d/yyyy h:mm:ss a' }}
                      </a>
                    </td>
                  </ng-container>
                  <ng-container lcsColumnDef="userActionsMenu" width="1">
                    <th lcs-header-cell *lcsHeaderCellDef id="user-actions-menu-column-header"></th>
                    <td lcs-cell *lcsCellDef="let user">
                      <button
                        type="button"
                        aria-label="User Actions"
                        matTooltip="More Actions"
                        mat-icon-button
                        [matMenuTriggerFor]="usersMenu"
                        id="user-more-actions"
                        >
                        <mat-icon> more_horiz </mat-icon>
                      </button>
                      <mat-menu #usersMenu="matMenu">
                        <a mat-menu-item [routerLink]="getRouterLink(user.userId)"> Details </a>
                      </mat-menu>
                    </td>
                  </ng-container>
                </table>
              </lcs-responsive-table>
            </ndt-register-view>
